module.exports = __webpack_public_path__ + "static/img/mapCenter.8afa336.png";


//////////////////
// WEBPACK FOOTER
// ./static/imgV2/mapCenter.png
// module id = PS1P
// module chunks = 1